var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.databases.length > 0)?_c('div',[_c('div',{staticClass:"select-application__group"},[_vm._v(_vm._s(_vm.workspace.name))]),_vm._v(" "),_c('ul',{staticClass:"select-application__list"},_vm._l((_vm.databases),function(database){return _c('li',{key:database.id},[_c('nuxt-link',{staticClass:"select-application__link",class:{ active: _vm.selected === database.id },attrs:{"to":{
          name: 'database-api-docs-detail',
          params: {
            databaseId: database.id,
          },
        }}},[_c('div',{staticClass:"select-application__icon"},[_c('i',{class:database._.type.iconClass})]),_vm._v(" "),_c('div',{staticClass:"select-application__name"},[_vm._v("\n          "+_vm._s(database.name)+"\n        ")])])],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }